// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ou-0";